import { IDeveloperV2 } from '../../../types/developerV2/developer';
import { getNewReactionCount } from './getNewReactionCount';
import { TSetReviewReactionActionPayload } from '../../../actions/reviews/actions';

export const changeReviewReactionType = (
  developer: IDeveloperV2,
  payload: TSetReviewReactionActionPayload,
): IDeveloperV2 => {
  if (!developer || !developer.reviews) {
    return developer;
  }

  return {
    ...developer,
    reviews: developer.reviews.map(review => {
      if (review.id === payload.reviewId) {
        return {
          ...review,
          like: {
            ...getNewReactionCount(review.like.status)[payload.type](review.like),
            status: payload.type,
          },
        };
      }

      return review;
    }),
  };
};
